<button type="button" class="btn nav-link"
    id="user-info"
    data-toggle="dropdown"
    aria-haspopup="true"
    aria-expanded="false">
    <div class="d-flex align-items-center">
        <i class="mdi mdi-account font-24"></i>
    </div>
</button>
<div class="dropdown-menu dropdown-menu-right p-2" aria-labelledby="user-info">
    <div class="px-2 py-1">
        <i class="bi bi-person-badge"></i>
        <span class="ml-2">
            {{currentUserInfo.userNm}}
        </span>
    </div>
    <div class="px-2 py-1">
        <i class="bi bi-person-badge"></i>
        <span class="ml-2 text-muted">
            {{currentUserInfo.userId}}
        </span>
    </div>
    <div class="px-2 py-1">
        <i class="bi bi-person-badge"></i>
        <span class="ml-2 text-muted">
            {{currentUserInfo.userGroupNm}}
        </span>
    </div>
    <div class="px-2 py-1">
        <i class="bi bi-building"></i>
        <span class="ml-2 text-muted">
            {{currentUserInfo.companyNm}}
        </span>
    </div>
    <div class="px-2 py-1">
        <i class="bi bi-info-circle"></i>
        <span class="ml-2 text-muted">
            {{ipAccessDevice}}
        </span>
    </div>
    <div class="px-2 py-1">
        <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="checkbox_cluster" [(ngModel)]="currentUserInfo.showMapCluster" (change)="checkValue(currentUserInfo)"/>
            <label class="form-check-label" for="checkbox_cluster">Show Cluster</label>
        </div>
    </div>
    <div class="dropdown-divider"></div>
    <button type="button" class="dropdown-item p-2" (click)="clickLogOut()">
        <i class="bi bi-power"></i>
        <span class="ml-2">
            Logout
        </span>
    </button>
</div>